import { render } from "./LeaveListTable.vue?vue&type=template&id=2e68cbb4&scoped=true"
import script from "./LeaveListTable.vue?vue&type=script&lang=js"
export * from "./LeaveListTable.vue?vue&type=script&lang=js"

import "./LeaveListTable.vue?vue&type=style&index=0&id=2e68cbb4&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e68cbb4"]])

export default __exports__